$(function () {
    // メモ：将来的にUser-Agent Clients Hints APIを利用する必要があるかも
    // 202204時点でブラウザカバー率が低いため、User-Agentでの判定とする
    if($('#mvl').length) {
        $('#mvl').html('');
        if(navigator.userAgent.match(/(Mac OS|iPad)/i) && !navigator.userAgent.match(/(iPhone|iPod)/i) ) {
            // imac、mac pro、mac air、iPadの場合
            $('#mvl').append('<video muted autoplay loop playsinline><source src="/img/home/mvl/emagen_mvl_iMac.mp4?ver2" type="video/mp4" loading="lazy"></video>');
        }else if(navigator.userAgent.match(/(iPhone|iPod)/i)) {
            //  iPhoneとiPodの場合
            $('#mvl').append('<video muted autoplay loop playsinline><source src="/img/home/mvl/emagen_mvl_iphone.mp4?ver2" type="video/mp4" loading="lazy"></video>');
        }else if(navigator.userAgent.match(/(Android)/i)) {
            //  Androidの場合
            if(navigator.userAgent.match(/(Mobile)/i)) {
                // Androidのスマホの場合
                    $('#mvl').append('<video muted autoplay loop><source src="/img/home/mvl/emagen_mvl_android-phone.mp4?ver2" type="video/mp4" loading="lazy"></video>');
                } else {
                    // Androidのタブレットの場合
                    $('#mvl').append('<video muted autoplay loop><source src="/img/home/mvl/emagen_mvl_android-tab.mp4?ver2" type="video/mp4" loading="lazy"></video>');
                }
        } else {
            // PCの場合
            $('#mvl').append('<video muted autoplay loop><source src="/img/home/mvl/emagen_mvl_pc.mp4?ver2" type="video/mp4" loading="lazy"></video>');
        };
    }

/*==================================================
//search セレクトボックスを選択したら選択したものを表示  複数選択
==================================================*/
    if($('.search').length) {
        if($('.js-search-selected-checkbox').length) {
            $('.js-search-selected-checkbox').on('click', function () {
                if ($(this).find('.field-checkbox-input').prop("checked") == true) {
                    let result = $(this).closest('.form-content').children('.select-result');
                    let selectCkeckBox = $(this).find('span').text();
                    let text = $(this).closest('.form-content').children('.select-result').html();
                    let regExp = new RegExp('<span class="no-select">指定しない</span>', "g");
                    // textから「指定しない」を絞りこむ
                    let selected = text.replace(regExp, "");
                    $(this).closest('.form-content').children('.select-result').html(selected);
                    result.children('.selected').append("<span>" + selectCkeckBox + "</span>");

                } else {
                    let selectedTag = $(this).closest('.form-content').children('.select-result').children('.selected');
                    let selectedProduct = selectedTag.html();
                    // チェックした項目の結果
                    let selectCkeckBox = $(this).find('.checkbox-parts').text();
                    // チェックした項目のラベルテキストを取り出す。
                    let removeProduct = "<span>" + selectCkeckBox + "</span>";
                    // チェックした項目のラベルテキストにspanタグをつける
                    let regExp = new RegExp(removeProduct, "g");
                    // spanタグをつけたものを結果から絞り込む
                    let selected = selectedProduct.replace(regExp, "");
                    // 絞り込んだものを結果から削除する
                    selectedTag.html(selected);
                    // 取り出して残ったものをselectedクラスの要素の中に戻す。
                };
            });
            // 選択が1つもない時、「指定しない」を戻す。
            $('.js-search-selected-checkbox').on('click', function () {
                if ($(this).find('.field-checkbox-input').prop("checked") == false) {
                    let selectedTag = $(this).closest('.form-content').children('.select-result').children('.selected');
                    let result = $(this).closest('.form-content').children('.select-result');
                    if (selectedTag.find('span').length == 0) {
                        result.append('<span class="no-select">指定しない</span>');
                    }
                };
            });
        }

/*==================================================
//search セレクトボックスを選択したら選択したものを表示  1つだけ選択
==================================================*/
        // 都道府県を1つだけチェックできるように
        $('[name="state_ids[]"]').on("click", function(){
            if ($(this).prop('checked')){
                $('[name="state_ids[]"]').prop('checked', false);
                $(this).prop('checked', true);
            }
        });
        // 相談メニューを1つだけチェックできるように
        $('[name="request_company_types[]"]').on("click", function(){
            if ($(this).prop('checked')){
                $('[name="request_company_types[]"]').prop('checked', false);
                $(this).prop('checked', true);
            }
        });

        if($('.js-search-selected-checkbox-only').length) {
            $('.js-search-selected-checkbox-only').on('click', function () {
                if ($(this).find('.field-checkbox-input').prop("checked") == true) {
                    let result = $(this).closest('.form-content').children('.select-result');
                    let selectCkeckBox = $(this).find('span').text();
                    let text = $(this).closest('.form-content').children('.select-result').html();
                    let regExp = new RegExp('<span class="no-select">指定しない</span>', "g");
                    // textから「指定しない」を絞りこむ
                    let selected = text.replace(regExp, "");
                    $(this).closest('.form-content').children('.select-result').html(selected);
                    result.children('.selected').html('');
                    result.children('.selected').append("<span>" + selectCkeckBox + "</span>");

                } else {
                    let selectedTag = $(this).closest('.form-content').children('.select-result').children('.selected');
                    let selectedProduct = selectedTag.html();
                    // チェックした項目の結果
                    let selectCkeckBox = $(this).find('.checkbox-parts').text();
                    // チェックした項目のラベルテキストを取り出す。
                    let removeProduct = "<span>" + selectCkeckBox + "</span>";
                    // チェックした項目のラベルテキストにspanタグをつける
                    let regExp = new RegExp(removeProduct, "g");
                    // spanタグをつけたものを結果から絞り込む
                    let selected = selectedProduct.replace(regExp, "");
                    // 絞り込んだものを結果から削除する
                    selectedTag.html(selected);
                    // 取り出して残ったものをselectedクラスの要素の中に戻す。
                };
            });
            // 選択が1つもない時、「指定しない」を戻す。
            $('.js-search-selected-checkbox-only').on('click', function () {
                if ($(this).find('.field-checkbox-input').prop("checked") == false) {
                    let selectedTag = $(this).closest('.form-content').children('.select-result').children('.selected');
                    let result = $(this).closest('.form-content').children('.select-result');
                    if (selectedTag.find('span').length == 0) {
                        result.append('<span class="no-select">指定しない</span>');
                    }
                };
            });
        }

    }
});

$(function () {
    $('.favorite-btn, .message-btn, .event-btn, .feature-btn').on('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
    });
    $('.favorite-btn').on('click', function (e) {
        if ($(this).hasClass('push')) {
            $(this).removeClass('push');
            $(this).find('svg').attr('data-prefix', 'far');
        } else {
            $(this).find('svg').attr('data-prefix', 'fas');
            $(this).addClass('push');
        };
    });
})


$('.yt_video').on(oEventNames.end ,function (event) {
    if (!bIsScrolling) {
        event.preventDefault();
        video = '<div class="yt_video_iframe"><iframe id="player" src="' + $(this).attr('youtube') + '" frameborder="0"></iframe></div>';
        $(this).replaceWith(video);
    }
});